import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { APP_ID, ApplicationConfig, LOCALE_ID, importProvidersFrom, isDevMode, inject, provideAppInitializer, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRouteProviders } from './app-routing.module';
import { Meta, provideClientHydration, withHttpTransferCacheOptions, withIncrementalHydration } from '@angular/platform-browser';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { ConfigService } from './services/config.service';
import { MatDateFormats, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { HttpUrlInterceptor } from './http-url.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { WebLanguageService } from './services/translate/web-language.service';
import { I18nService } from './services/i18n.service';
import { LanguageService } from './services/translate/language.service';
import { CleverErrorHandler } from './services/clevererrorhandler.service';

export class DynamicLocaleId extends String {
    constructor(protected service: I18nService) {
        super('');
    }

    override toString() {
        return this.service.langLong;
    }
}

const initializeAppFactory = () => {
    return () => inject(ConfigService).init();
}

const initializeRecapcha = () => {
    return () => inject(ConfigService).loadConfig();
}

const GRI_DATE_FORMATS: MatDateFormats = {
    ...MAT_NATIVE_DATE_FORMATS,
    display: {
        ...MAT_NATIVE_DATE_FORMATS.display,
        dateInput: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        } as Intl.DateTimeFormatOptions,
    }
};

export const appConfig: ApplicationConfig = {
    providers: [
        ...AppRouteProviders,
        provideAnimations(),
        provideZonelessChangeDetection(),
        provideHttpClient(withFetch(), withInterceptors([HttpUrlInterceptor])),
        provideClientHydration(withIncrementalHydration(), withHttpTransferCacheOptions({
            includePostRequests: true
        })),
        importProvidersFrom(ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            // registrationStrategy: 'registerWhenStable:30000'
            registrationStrategy: 'registerImmediately'
        })),
        { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS },
        Meta,
        {
            provide: LOCALE_ID,
            useValue: 'de-DE'
        },
        { provide: APP_ID, useValue: 'cleverreisen' },
        { provide: ErrorHandler, useClass: CleverErrorHandler },
        { provide: LanguageService, useClass: WebLanguageService },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useFactory: (config: ConfigService) => {
                // await config.loadConfig().then(() => console.log('config resolved'));
                return config.recaptchaSiteKeyV3;
            },
            deps: [ConfigService],
            // useValue: '6LfRh1IeAAAAAHtWRke9B5YG-QTnu3HpBhzAckg0'
        },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: CleverInterceptor,
        //     multi: true
        // },
        provideAppInitializer(initializeAppFactory()),
        provideAppInitializer(initializeRecapcha()),
    ],
};
